<template>
    <li class="group cursor-pointer uppercase px-0 lg:px-1 lg:px-2">
        <a class="group-hover:text-blue-400 text-lg lg:text-sm tracking-widest block py-4 lg:py-1 rounded-md select-none px-4 lg:px-2"
            :class="active ? 'text-blue-400' : 'text-gray-400'"
            :href="href"
        >
            {{ $t(label) }}
        </a>
    </li>
</template>

<script>
export default {
    props: {
        label: {},
        href: {},
        active: { default: false },
    },
}
</script>

